
export const initQueryPrototypes = (prototypes) => ({
    type:"QUERY_PROTOTYPE_INIT",
    prototypes,
});